<template>
<div class="fix-header">
  <header class="header">
    <span v-if="!noBack" class="back-btn" @click="goBack">
      <img class="back-icon" src="~@/images/electronicLetter/back.png" alt="" />
    </span>
    <span v-else class="back-btn"></span>
    <div class="title">{{ titleName}}</div>
    <span class="right"></span>
  </header>
</div>
</template>

<script>
export default {
  name: 'h5-header',
  props: {
    noBack: {
      default: false
    },
    titleName: {
      type: String,
      default: ''
    },
    leftArrowCallback: {
      default: null
    }
  },
  methods: {
    goBack () {
      if (this.leftArrowCallback) {
        return this.leftArrowCallback()
      }
      this.$router.go(-1)
    }
  }
}
</script>

<style lang='scss' scoped>
$fixHeight: 85px;
.fix-header {
  z-index: 111;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: $fixHeight;
}
.header {
  height: $fixHeight;
  padding: 0 12px;
  background-color: #fff;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eee;
  .back-btn {
    padding: 16px;
    width: 18px;
    .back-icon {
      width: 18px;
      height: 32px;
    }
  }
  .title {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 14px;
    font-size: 32px;
    color: #222;
  }
  .right {
    width: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/h5-header.vue